import axios from 'axios'
import { BLOCK_EMPLOYEE_URL } from './consts'

export const postBlockEmployee = (id: number) => {
  return axios.post(`${BLOCK_EMPLOYEE_URL}${id}`, {
    enabled: false,
  })
}
